import type { NodeDefinition } from "../domain/types/index.js";

function node(id: string, kind: NodeDefinition["kind"], x: number, y: number, next: readonly string[]): NodeDefinition {
  return { id, kind, x, y, next, ...(kind === "case" ? { caseId: id === "boss" ? "window-seat-boss" : id } : {}) };
}

// 第19期。面談・特命・循環の3地域。イベントは共有2PJの後に分散させ、
// 窓際を減らすか、残して使うか、増える負債を引き受けるかを局所的に選ばせる。
export const MAP_NODES_WINDOW_SEAT: Record<string, NodeDefinition> = Object.fromEntries([
  node("start", "start", 3, 0, ["p20-inventory"]),
  node("p20-inventory", "case", 3, 1, ["p20-alignment"]),
  node("p20-alignment", "case", 3, 2, ["p20-interview", "p20-policy", "p20-transfer"]),

  node("p20-interview", "case", 1, 3, ["p20-event-left", "p20-match"]),
  node("p20-event-left", "event", 0, 4, ["p20-match"]),
  node("p20-match", "case", 1, 5, ["p20-mentor", "p20-rest-left"]),
  node("p20-rest-left", "rest", 2, 6, ["p20-mentor"]),
  node("p20-mentor", "case", 1, 7, ["p20-left-review"]),
  node("p20-left-review", "case", 1, 8, ["p20-integration-left"]),

  node("p20-policy", "case", 3, 3, ["p20-event-center"]),
  node("p20-event-center", "event", 4, 4, ["p20-taskforce", "p20-event-center2"]),
  node("p20-event-center2", "event", 4, 5, ["p20-taskforce"]),
  node("p20-taskforce", "case", 3, 6, ["p20-center-review"]),
  node("p20-center-review", "case", 3, 8, ["p20-center-event"]),
  node("p20-center-event", "event", 3, 9, ["p20-integration-left", "p20-integration-right"]),

  node("p20-transfer", "case", 5, 3, ["p20-event-right", "p20-scout"]),
  node("p20-event-right", "event", 6, 4, ["p20-scout"]),
  node("p20-scout", "case", 5, 5, ["p20-handoff", "p20-rest-right"]),
  node("p20-rest-right", "rest", 4, 6, ["p20-handoff"]),
  node("p20-handoff", "case", 5, 7, ["p20-right-event", "p20-right-review"]),
  node("p20-right-event", "event", 6, 8, ["p20-right-review"]),
  node("p20-right-review", "case", 5, 9, ["p20-integration-right"]),

  node("p20-integration-left", "case", 2, 10, ["p20-settlement-left"]),
  node("p20-integration-right", "case", 4, 10, ["p20-settlement-right"]),
  node("p20-settlement-left", "case", 2, 12, ["boss"]),
  node("p20-settlement-right", "case", 4, 12, ["boss"]),
  node("boss", "case", 3, 14, []),
].map((item) => [item.id, item]));
